import bbox from '@turf/bbox';
import { useCallback, useRef, useState } from 'react';
import { Layer, Map, Source } from 'react-map-gl';
import PreviewButton, { monoStyle } from '../helpers/PreviewButton';

const BlockMap = ({ geom }) => {
  const [mapStyle, setMapStyle] = useState(monoStyle);
  const [initialBoundsSet, setInitialBoundsSet] = useState(false);
  const mapRef = useRef();

  const initialViewPort = {
    latitude: -41,
    longitude: 174.5,
    zoom: 4,
    height: 300,
    width: '100%'
  };

  const [viewport, setViewport] = useState(initialViewPort);

  const layer = {
    id: 'block-polygon-display',
    type: 'fill',
    paint: {
      'fill-color': '#28a745',
      'fill-opacity': 0.4
    }
  };

  const outlineLayer = {
    id: 'block-polygon-outline-display',
    type: 'line',
    paint: {
      'line-color': '#28a745',
      'line-width': 2
    }
  };

  const fitBounds = useCallback(
    (map) => {
      if (geom) {
        const [minLng, minLat, maxLng, maxLat] = bbox(geom);
        map.fitBounds(
          [
            [minLng, minLat],
            [maxLng, maxLat]
          ],
          { padding: 50, duration: 500 }
        );
      }
    },
    [geom]
  );

  const mapRefWrapper = useCallback(
    (node) => {
      if (node) {
        if (geom && !initialBoundsSet) {
          fitBounds(node);
          setInitialBoundsSet(true);
        }
      }
      mapRef.current = node;
    },
    [geom, fitBounds, initialBoundsSet]
  );

  if (!geom) return null;

  return (
    <Map
      ref={mapRefWrapper}
      reuseMaps
      mapboxAccessToken={process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}
      mapStyle={`${mapStyle}`}
      initialViewState={viewport}
      onViewportChange={(next) => setViewport(next)}
      scrollZoom={false}
      dragPan={false}
      dragRotate={false}
      touchPitch={false}
      keyboard={false}
      attributionControl={false}
    >
      <Source
        id='block-geom-display'
        type='geojson'
        data={{ type: 'Feature', geometry: geom, properties: {} }}
      >
        <Layer {...layer} />
        <Layer {...outlineLayer} />
      </Source>
      <PreviewButton
        setMapStyle={setMapStyle}
        mapStyle={mapStyle}
        viewport={viewport}
      />
    </Map>
  );
};

export default BlockMap;

